import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [sessionStoragePlugin],
  state: {
    drawerStatus: false,
    userData: null,
    selectCommunity: null,
    themeColor: "#33a6b8",
    themeColor_light: "#81c7d4",
    themeColor_light2: "#9dcfd9",

    windowWidth: 1024,
    windowHeight: 768,
    isMobile: false,
    // isAdmin: false,
    jwttoken: null,
    permissions: [],
    unreadNotificationCount: 0,
    fcmToken: null,
  },
  getters: {
    getThemeColor(state) {
      return state.themeColor;
    },
    getThemeColorLight(state) {
      return state.themeColor_light;
    },
    getThemeColorLight2(state) {
      return state.themeColor_light2;
    },
    getWindowWidth(state) {
      return state.windowWidth;
    },
    getWindowHeight(state) {
      return state.windowHeight;
    },
    getToken(state) {
      // return ls.get("jt");
      return state.jwttoken;
    },
    getSelectCommunity(state) {
      return state.selectCommunity;
    },
    // getCommunityName(state) {
    //   return state.communityName;
    // },
    getUser(state) {
      return state.userData;
    },
    isMobile(state) {
      return state.isMobile;
    },
    isDrawerShow(state) {
      return state.drawerStatus;
    },
    // hasModule(state, moduleName) {
    //   if (!moduleName) return true;

    //   for (let mi = 0; mi < state.selectCommunity.Module.length; mi++) {
    //     if (state.selectCommunity.Module[mi].Name == moduleName) {
    //       return true;
    //     }
    //   }
    //   return false;
    // },
  },
  mutations: {
    login(state, token) {
      state.jwttoken = token;
      window.localStorage.setItem("jwttoken", token);
    },
    setUser(state, user) {
      state.userData = user;
      window.localStorage.setItem("userData", JSON.stringify(user));
    },
    setDrawerShow(state, isShow) {
      state.drawerStatus = isShow;
    },
    setWindowResolution(state, { width, height }) {
      state.windowWidth = width;
      state.windowHeight = height;
      state.isMobile = width < 769;
    },
    setSelectCommunity(state, community) {
      state.selectCommunity = community;
      window.localStorage.setItem("selectCommunity", JSON.stringify(community));
    },
    // 只更新預設類型欄位，避免觸發整個 selectCommunity 的 watcher 導致無限迴圈
    updateCommunityDefaults(state, defaults) {
      if (defaults.DefaultPackageType !== undefined) {
        state.selectCommunity.DefaultPackageType = defaults.DefaultPackageType;
      }
      if (defaults.DefaultDepositType !== undefined) {
        state.selectCommunity.DefaultDepositType = defaults.DefaultDepositType;
      }
      if (defaults.DefaultFacilityType !== undefined) {
        state.selectCommunity.DefaultFacilityType = defaults.DefaultFacilityType;
      }
      if (defaults.DefaultShippingFrom !== undefined) {
        state.selectCommunity.DefaultShippingFrom = defaults.DefaultShippingFrom;
      }
      if (defaults.DefaultShippingProvider !== undefined) {
        state.selectCommunity.DefaultShippingProvider = defaults.DefaultShippingProvider;
      }
      if (defaults.DefaultVisitReason !== undefined) {
        state.selectCommunity.DefaultVisitReason = defaults.DefaultVisitReason;
      }
      if (defaults.DefaultVisitReasonCompany !== undefined) {
        state.selectCommunity.DefaultVisitReasonCompany = defaults.DefaultVisitReasonCompany;
      }
      window.localStorage.setItem("selectCommunity", JSON.stringify(state.selectCommunity));
    },
    setUnreadCount(state, count) {
      state.unreadNotificationCount = count;
    },
    setFcmToken(state, token) {
      state.fcmToken = token;
    },
    logout(state) {
      state.jwttoken = null;
      state.menuStatus = null;
      state.userData = null;
      window.localStorage.removeItem("jwttoken");
      window.localStorage.removeItem("selectCommunity");
      window.localStorage.removeItem("userData");
    },
  },
  actions: {},
  modules: {},
});

// Subscribe to store updates
// console.log(Vuex);
// Vuex.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   // localStorage.setItem('store', JSON.stringify(state));
//   console.log("[STORE] mutation :", mutation);
//   console.log("[STORE] state :", state);
// });
